var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("right-popup", {
        attrs: {
          show: _vm.isOpen,
          "border-left": false,
          "border-top": true,
          width: 300,
          "exclude-header": true,
          "exclude-header-toolbar": true,
          "exclude-footer": true,
          "custom-styles": _vm.additionalStyles,
          "portal-name": "portal-filter-sidebar",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.currentFilter
                  ? _c(
                      "div",
                      [
                        _c(_vm.componentName, {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.onClickOutside,
                              expression: "onClickOutside",
                            },
                          ],
                          key: _vm.componentName,
                          tag: "component",
                          attrs: {
                            filter: _vm.filterConfig,
                            "saved-filters": _vm.preparedSavedFilters,
                            "component-name": _vm.componentName,
                          },
                          on: {
                            changeFilter: _vm.changeFilter,
                            setFilter: _vm.applySavedFilter,
                            onSaveClick: _vm.onSaveClick,
                            onSave: _vm.onSave,
                            onResetClick: _vm.resetFilter,
                            onClose: _vm.close,
                            showHelpPopup: _vm.showHelpPopup,
                            backClick: function ($event) {
                              return _vm.changeComponent("filterMain")
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }